import { DroneEntity, DroneStatusType } from '@src/core/features';

export interface MapLocationEntity {
  address?: string;
  latitude: number;
  longitude: number;
}

export interface IDronesInitialState {
  selectedDrone: DroneEntity | null;
  hoveredDrone: DroneEntity | null;
  collapse: {
    [DroneStatusType.IDLE]: boolean;
    [DroneStatusType.MISSION]: boolean;
    [DroneStatusType.UPDATE_SOFTWARE_REQUIRED]: boolean;
  };
  location?: MapLocationEntity;
  showTakeoffConfirm: boolean;
  missionId?: string;
  manualControl: Record<string, boolean>;
  /** Serials of drones just put into a mission (create/takeoff) while REST status still lags. */
  optimisticMissionSerials: string[];
  /** Serials whose mission was just ended (END_MISSION SUCCESS); suppress their route until REST shows IDLE. */
  endedMissionSerials: string[];
}

const initialState: IDronesInitialState = {
  selectedDrone: null,
  hoveredDrone: null,
  collapse: {
    [DroneStatusType.IDLE]: true,
    [DroneStatusType.MISSION]: true,
    [DroneStatusType.UPDATE_SOFTWARE_REQUIRED]: true,
  },
  location: undefined,
  showTakeoffConfirm: false,
  missionId: undefined,
  manualControl: {},
  optimisticMissionSerials: [],
  endedMissionSerials: [],
};

export default initialState;
